<template>
    <div class="occupation-select select-tags">
        <Multiselect
            v-if="selectstyle === 'multiselect'"
            v-model="multiselectValue"
            :placeholder="trans('onboarding.step_2_question_2_placeholder')"
            :options="occupations"
            track-by="value"
            label="label"
            :searchable="true"
            :allow-empty="true"
            :option-height="20"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            :multiple="multiple"
            @select="updateValue"
            >
            <template #singleLabel="{ option }">
                {{ option.label }}
            </template>
            <template #noResult>
                {{ trans('feedback.please_select_other') }}
            </template>
        </Multiselect>

        <select v-else :id="id" :value="value" class="form-control" name="occupation" @input="updateValue($event.target)">
            <option v-for="occupation in occupations" :key="occupation.value" :value="occupation.value">
                {{ occupation.label }}
            </option>
        </select>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Apps from '@/core/Apps';
import { getAllOccupations } from '@/system/data/occupation';

export default {
    components: {
        Multiselect
    },

    props: {
        value: {
            type: [String, Array]
        },
        preselected: {
            required: false,
            type: String,
            default: ''
        },
        selectstyle: {
            type: String,
            required: false,
            default: 'multiselect' // multiselect, select
        },
        id: {
            type: String,
            required: false,
        },
        multiple: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    emits: ['update:modelValue', 'input'],

    data() {
        return {
            occupations: [],
            updateKey: 0,
            multiselectValue: '',
        }
    },

    computed: {
        is_helsenett_active() {
            return this.$store.getters['apps/isAppEnabled'](Apps.Helsenett);
        },
    },
    watch: {
        multiselectValue(val) {
            if (this.multiple) {
                this.$emit('input', val)
            }
        },
        value(val) {
            if (this.multiple) {
                this.multiselectValue = val
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.occupations = getAllOccupations(this.is_helsenett_active);
        });
    },

    methods: {
        updateValue(occupation) {
            if (! this.multiple) {
                this.$emit('input', occupation.value);
            }
        },
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
